import { render, staticRenderFns } from "./tipspointsale-show.vue?vue&type=template&id=367acb3a"
import script from "./tipspointsale-show.vue?vue&type=script&lang=js"
export * from "./tipspointsale-show.vue?vue&type=script&lang=js"
import style0 from "./tipspointsale-show.vue?vue&type=style&index=0&id=367acb3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports